<template>
  <div class="blog" :key="selectedCategory">

    <!-- <h1>{{this.page}} this mf page</h1>
    <h1>{{this.total_pages}} total pages</h1> -->
    <!-- <v-row class="row maw940 center-hori mt50 mt10@md"> -->

      <!-- <div :key="selectedCategory + page"> -->

          <blogpostcard
            v-for="post in posts"
            :key="post.id"
            :slug="post.slug"
            :title="post.title"
            :desc="post.desc"
            :media="post.media"
            :uid="post.uid"
            :date="post.date"
            :categories="post.categories"
          />

      <!-- </div> -->

      <infinite-loading spinner="spiral" :identifier="selectedCategory" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results">No posts</div>
      </infinite-loading>

      <!-- <div class="text-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="8">
              <v-container class="max-width">
                <v-pagination
                  v-model="page"
                  :length="total_pages"
                  color="#e9640a"
                ></v-pagination>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div> -->

    <!-- </v-row> -->
  </div>
</template>

<style scoped>


</style>

<script>
import blogpostcard from './blog-post-material-card'
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: {
    blogpostcard,
    InfiniteLoading,
  },
  props: {
    category: {type: String},
  },

  created: function() {
    this.selectedCategory = this.category;
    // this.getPosts(this.selectedCategory, 1);
  },
  // watch: {
  //   page: function () {
  //     this.getPosts(this.selectedCategory, this.page);
  //   },
  // },
  methods: {
    // getPosts (requestedCategory, requestedPage) {
    //   if (requestedCategory == 'all' || requestedCategory == undefined) {
    //     // Get all posts to populate the list cards
    //     this.$prismic.client.query( // start the all query
    //       this.$prismic.Predicates.at("document.type", "post"),
    //         { page: requestedPage || '1', pageSize: 6, orderings: '[my.post.date desc]', fetch : ['post.date', 'post.title', 'post.media', 'post.slugs', 'post.description', 'post.categories'] }
    //     ).then((response) => {
    //       this.total_pages = response.total_pages
    //       this.page=response.page;
    //       this.posts=[]
    //       response.results.forEach(returnedPost => {
    //         this.posts.push(
    //           {
    //             slug: returnedPost.slugs[0],
    //             title: returnedPost.data.title[0].text,
    //             desc: returnedPost.data.description[0].text,
    //             date: returnedPost.data.date,
    //             media: returnedPost.data.media.url,
    //             uid: returnedPost.uid,
    //             categories: returnedPost.data.categories
    //           }
    //         )
    //       });
    //     }) // end the all query
    //   } else {
    //     // Get all posts to populate the list cards
    //     this.$prismic.client.query([ // start the all query
    //       this.$prismic.Predicates.at("document.type", "post"),
    //       this.$prismic.Predicates.at('my.post.categories.category',requestedCategory)],
    //         { page: requestedPage || '1', pageSize: 6, orderings: '[my.post.date desc]', fetch : ['post.date', 'post.title', 'post.media', 'post.slugs', 'post.description', 'post.categories'] }
    //     ).then((response) => {
    //       this.total_pages = response.total_pages
    //       this.page=response.page;
    //       this.posts=[]
    //       response.results.forEach(returnedPost => {
    //         this.posts.push(
    //           {
    //             slug: returnedPost.slugs[0],
    //             title: returnedPost.data.title[0].text,
    //             desc: returnedPost.data.description[0].text,
    //             date: returnedPost.data.date,
    //             media: returnedPost.data.media.url,
    //             uid: returnedPost.uid,
    //             categories: returnedPost.data.categories
    //           }
    //         )
    //       });
    //     }) // end the all query
    //   }
    // },
    infiniteHandler($state) {
      if (this.selectedCategory == 'all' || this.selectedCategory == undefined) {
        // Get all posts to populate the list cards
        this.$prismic.client.query( // start the all query
          this.$prismic.Predicates.at("document.type", "post"),
            { page: this.page || '1', pageSize: 4, orderings: '[my.post.date desc]', fetch : ['post.date', 'post.title', 'post.media', 'post.slugs', 'post.description', 'post.categories'] }
        ).then((response) => {
          this.total_pages = response.total_pages
          this.page=this.page+1;
          // if(response.results.length) {
          if(this.page <= response.total_pages+1) {
            response.results.forEach(returnedPost => {
              this.posts.push(
                {
                  slug: returnedPost.slugs[0],
                  title: returnedPost.data.title[0].text,
                  desc: returnedPost.data.description[0].text,
                  date: returnedPost.data.date,
                  media: returnedPost.data.media.url,
                  uid: returnedPost.uid,
                  categories: returnedPost.data.categories
                }
              )
            });
            $state.loaded();
          } else {
            $state.complete();
          }
        }) // end the all query
      } else {
        // Get all posts to populate the list cards
        this.$prismic.client.query([ // start the all query
          this.$prismic.Predicates.at("document.type", "post"),
          this.$prismic.Predicates.at('my.post.categories.category',this.selectedCategory)],
            { page: this.page || '1', pageSize: 4, orderings: '[my.post.date desc]', fetch : ['post.date', 'post.title', 'post.media', 'post.slugs', 'post.description', 'post.categories'] }
        ).then((response) => {
          this.total_pages = response.total_pages
          this.page=this.page+1;
          // this.posts=[]
          // if(response.results.length) {
          if(this.page <= response.total_pages+1) {
            response.results.forEach(returnedPost => {
              this.posts.push(
                {
                  slug: returnedPost.slugs[0],
                  title: returnedPost.data.title[0].text,
                  desc: returnedPost.data.description[0].text,
                  date: returnedPost.data.date,
                  media: returnedPost.data.media.url,
                  uid: returnedPost.uid,
                  categories: returnedPost.data.categories
                }
              )
            });
            $state.loaded();
          } else {
            $state.complete();
          }
        }) // end the all query
      }
    },
  },
  data() {
    return {
      categories: [],
      posts: [],
      selectedCategory: 'all',
      page: 1,
      total_pages: 1,
    }
  },
}
</script>